import React, {Component} from 'react';
import './style/schedule.css';
import Error from './../../ui_core/message/errors';
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style/statistic.css";
import Graph from './graph';
import enGB from 'date-fns/locale/en-GB';

registerLocale('en-GB', enGB);

class Schedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
        };
        this.handleChange = this.handleChange.bind(this);
        this.getData = props.getData;
    }

    formatDate(day) {
        return 'Y-m-d'
            .replace('Y', day.getFullYear())
            .replace('m', (day.getMonth() + 1) > 9 ? (day.getMonth() + 1) : ('0' + (day.getMonth() + 1)))
            .replace('d', day.getDate() > 9 ? day.getDate() : '0' + day.getDate());
    }

    getFirstWeekDay(day) {
        const weekDay = day.getUTCDay();
        const isoWeekDay = weekDay === 0 ? 7 : weekDay - 1;
        const firstWeekDay = new Date(day.getTime() - isoWeekDay * 86400000);

        return this.formatDate(firstWeekDay);
    }

    getNextDay(dayString) {
        const day = new Date(dayString);
        const nextDay = new Date(day.getTime() + 86400000);

        return this.formatDate(nextDay);
    }
    normalizeHrs(hr){
        return hr < 10 ? '0' + hr : hr;
    }

    isBeforeThanLastDate(day, hr, lastDayData) {
        const dayTime = new Date(day + 'T' + this.normalizeHrs(hr) + ':00').getTime();
        const lastDayTime = new Date(lastDayData.day + 'T' + this.normalizeHrs(lastDayData.hour) + ':00').getTime();

        return dayTime <= lastDayTime;
    }

    createEmptyItems(dayArr, day, lastDayData) {
        for (let i = 0; i < 24; i++) {
            let isExist = dayArr.filter((item) => item.hour === i).length;
            if (!this.isBeforeThanLastDate(day, i, lastDayData)) {
                break;
            }
            if (!isExist) {
                dayArr.push({ "hour": i, "day": day, "volume": 0, "processed": 0, "postponed": 0 });
            }
        }
    }

    completeData(data) {
        const fullDataDay = [];
        let lastDayData;
        let res = [];
        let existingDay;
        let day;

        if (data.length) {
            lastDayData = data[data.length - 1];
            existingDay = new Date(data[0].day);
            day = this.getFirstWeekDay(existingDay);

            for (let i = 0; i < 7; i++) {
                let newDay = data.filter(item => item.day === day);
                this.createEmptyItems(newDay, day, lastDayData);
                newDay.sort((a, b) => {
                    let res = 0;
                    if (a.hour < b.hour) {
                        res = -1;
                    }
                    if (a.hour > b.hour) {
                        res = 1;
                    }
                    return res;
                });
                fullDataDay.push(newDay);
                day = this.getNextDay(day);
            }
        }

        fullDataDay.forEach((day) => res = res.concat(day));

        return res;
    }

    getGraphData(date) {
        this.getData('/log/get', '?date=' + this.formatDate(date))
            .then(data => {
                this.props.changeState({ data: this.completeData(data) });
            });
    }

    handleChange(date) {
        this.getGraphData(date);
        this.setState({ startDate: date });
    }

    componentDidMount() {
        this.getGraphData(new Date());
    }

    render() {
        return (
            <div className="defaultWrapper">
                <div className="wrapper_row">
                    <div className="right-col">
                        <div className="content">
                            {Object.keys(this.props.state.message).length ?
                                <Error {...this.props.state.message} /> : ''}
                            <div className="datepickerWraper">
                                <label htmlFor="weekChooser">
                                    Choose week:
                                </label>
                                <DatePicker
                                    id='weekChooser'
                                    selected={this.state.startDate}
                                    onChange={this.handleChange}
                                    locale="en-GB"
                                    dateFormat="dd/MM/yyyy"
                                    showWeekNumbers
                                />
                            </div>
                            <div className="graphBlock">
                                {this.props.state.data.length ? <Graph {...this}/> : 'No Data for this period'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
export default Schedule;
